import { render, staticRenderFns } from "./meals.vue?vue&type=template&id=10edbf90&"
import script from "./meals.vue?vue&type=script&lang=js&"
export * from "./meals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports